import { OfficialLineup as OfficialLineupComponent } from './OfficialLineup.component';
import { connector } from './OfficialLineup.connector';

export const OfficialLineup = connector(OfficialLineupComponent);
